<mat-radio-button
    #inputElement
    color="primary"
    [checked]="isChecked"
    (click)="onClick()"
></mat-radio-button>
